import * as ko from "knockout";
import {IMutableSyncfieldParameters, ITypeParams, TParameterType} from "../index";
import {DynamicProperties} from "../DynamicProperties";
import {ObjectTypeId} from "../../../../../constants";
import {memoryStore} from "../../../../../util/memorystore";
import {global} from "../../../../../appContext";
import {KOSubscriptionTracker} from "../../../../../util/KOSubscriptionTracker";
import {ErrorTracker} from "../../../../../error.tracker";
import AbstractTypeHtml from './AbstractType.html?raw';
import AbstractTypePropertiesHtml from './AbstractTypeProperties.html?raw';

const template = AbstractTypeHtml;
const templateProperties = AbstractTypePropertiesHtml;

export function getTemplate(contents: string = templateProperties): string {
    return template.replace('<!-- TEMPLATE -->', contents);
}

export abstract class AbstractType {
    private readonly defaultValues: KnockoutObservableArray<any> = ko.observableArray(null);
    private readonly toggleSummary: KnockoutObservable<boolean> = memoryStore.get("dynamic.element.show.summary", true);
    protected readonly ObjectTypeId = ObjectTypeId;
    protected readonly dynamicProperties: DynamicProperties;
    protected readonly observables: KnockoutObservableArray<IMutableSyncfieldParameters>;
    protected readonly parameterTypes!: TParameterType[];
    protected readonly showSubmitButton: boolean = true;
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    protected readonly et: ErrorTracker = global.errorAreas.get('dynamic.properties');

    constructor(protected params: ITypeParams) {
        this.dynamicProperties = params.dynamicProperties;
        this.observables = this.dynamicProperties.observables;
        this.defaultValues(this.observables().map(o => o.val()));

        const parameterOptions = this.observables().find(o => o.parameter.startsWith('Liste over valg'));
        if (parameterOptions) {
            const validateOptions = () => {
                this.et.update(parameterOptions.val() == '', parameterOptions.val, 'invalid value');
            }
            this.kosub.subscribe(parameterOptions.val, validateOptions)
            validateOptions();
        }
    }

    protected isChanged(): boolean {
        return !this.observables().every((o: IMutableSyncfieldParameters, index: number) => {
            return o.val() == this.defaultValues()[index];
        });
    }

    protected onSubmit(): void {
        this.dynamicProperties.submit();
        this.defaultValues(this.observables().map(o => o.val()));
    }

    protected onDiscardChangesClick(): void {
        this.observables().forEach((o: IMutableSyncfieldParameters, index: number) => o.val(this.defaultValues()[index]));
    }

    private onToggleSummaryClick(vm: AbstractType, e: JQuery.Event) {
        this.toggleSummary(!this.toggleSummary());
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }

}